module.exports = __webpack_public_path__ + "img/tests_results.68c078e3.svg";